module.exports = __webpack_public_path__ + "static/media/pyv-edit-delete-select-pyv-click-delete-all.b03c4be8.gif";